export default "assets/images/icons/skills-ab39692f.svg";